/*

  f e a t u r e s  -  v i r t u a l  r o o m  q u e s t i o n n a i r e
  Features - Virtual Room Questionnaire Slice

  :description:
  Our reducer for the virtual room questionnaire feature.

*/

//
//  :react & redux:
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

//
//  :code:
import { submitForm } from './virtualRoomQuestionnaireAPI';

//
//  :statics:

//
//  :functions:

//
//  :state:
//  Our initial state object.
const initialState = {
  formSubmission: {
    status: "idle",
    requesting: false,
    error: null,
    response: null,
  }
};

//
//  :async actions:
export const formSubmissionAsync = createAsyncThunk(
  'virtualRoomQuestionnaire/formSubmission',
  async (payload) => {
    const response = await submitForm(payload)
    return response
  }
);


//
//  :reducer:
export const virtualRoomQuestionnaireSlice = createSlice({
  name: 'virtualRoomQuestionnaire',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(formSubmissionAsync.pending, (state) => {
        state.formSubmission.status = 'requesting';
        state.formSubmission.requesting = true
        state.formSubmission.error = null
        state.formSubmission.response = null
      })
      .addCase(formSubmissionAsync.fulfilled, (state, action) => {
        state.formSubmission.status = 'idle';
        state.formSubmission.requesting = false
        state.formSubmission.response = action.payload
      })
      .addCase(formSubmissionAsync.rejected, (state, action) => {
        state.formSubmission.status = 'error';
        state.formSubmission.requesting = false
        state.formSubmission.error = action.error
      })
  },
});

//
//  :sync actions:
//export const { logout } = authSlice.actions;

//
//  :exports:

export const selectFormSubmissionStatus = (state) => state.virtualRoomQuestionnaire.formSubmission.status;
export const selectFormSubmissionRequesting = (state) => state.virtualRoomQuestionnaire.formSubmission.requesting;
export const selectFormSubmissionError = (state) => state.virtualRoomQuestionnaire.formSubmission.error;
export const selectFormSubmissionResponse = (state) => state.virtualRoomQuestionnaire.formSubmission.response;


//
//  :exports:
export default virtualRoomQuestionnaireSlice.reducer;
